export const DOCUMENT_TYPE_CATEGORY = 'commerce.category';
